export default {"src":"/_next/static/media/diamond.5c32f63e.svg","height":18,"width":21};